import { TCollection, TEntityRef, TNote } from '@ws/shared/types';
import {
  collectTkMarkers,
  getCompiledContentOfEntity,
  ITkMarkerRef,
  TGetNodesByRefs,
} from '@ws/shared/utils';

export interface ITkMarkersResult {
  markers: ITkMarkerRef[];
  /**
   * Сколько ссылок обход не смог разрешить.
   *
   * Ноль меток при непустом счётчике — это не «всё дописано», а «часть заметок
   * не загрузилась». Панель обязана различать эти два случая: доверие к счётчику
   * — единственное, ради чего она существует.
   */
  missingCount: number;
}

/**
 * Считает список меток выбранной сущности.
 *
 * Дорогая операция: обход делает глубокую копию каждой заметки и разбирает её
 * HTML. Замер на книге в 300 заметок (1.2 МБ) дал порядка 270 мс под jsdom —
 * поэтому вызывать её прямо в рендере нельзя, см. useTkMarkers.
 */
export function computeTkMarkers(
  entity: TCollection | TNote,
  getNodesByRefs: TGetNodesByRefs,
): ITkMarkersResult {
  const missing: TEntityRef[] = [];
  const compiled = getCompiledContentOfEntity(entity, getNodesByRefs, (ref) => missing.push(ref));

  return { markers: collectTkMarkers(compiled.content), missingCount: missing.length };
}
